import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m16 13.2-.784.545.277-.913-.761-.577.955-.02.313-.902.314.902.954.02-.76.576.276.914zm3.526.804-.943.147.65-.7-.432-.852.867.4.677-.672-.114.948.85.435-.937.185-.152.943zM21.444 16l.917.266.07.953.536-.79.927.228-.585-.754.503-.811-.898.324-.616-.73.03.954zm2.486 3.526-.708-.641.953.064.39-.871.234.925.95.103-.809.508.196.935-.733-.612-.828.475zm-15.505.886-.355-.886.708-.641-.953.064-.39-.871-.234.925-.95.103.809.508-.196.935.733-.612zm1.214-4.146-.07.953-.536-.79-.927.228.586-.754-.504-.811.898.324.616-.73-.03.954.884.36zm2.37-1.427.464-.834.944.147-.65-.7.432-.852-.867.4-.677-.672.114.948-.85.435.937.185z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagVen = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVen_default = SvgFlagVen;

export { FlagVen_default as default };
